'use client';

import type { RegisterFormInput } from '@eliadmin/core/src/components/dlz/auth/register/register-schema';
import { formFields } from '@eliadmin/core/src/components/dlz/forms/form-fields';

/** The DLZ form fields bound to the registration form. */
export const { TextField, PasswordField, CountryField, CheckboxField } =
  formFields<RegisterFormInput>();
